import React, { memo, useEffect, useState } from "react"
import { connect } from "react-redux"
import { mapDispatchProps, mapStateToProps } from "../store/store"

import AmbassadorApplicantsToast from "../components/AmbassadorApplicantsToast"
import { LOCALES } from "constants/locales"
import { isEmpty } from "helpers/object"

const Page = (props: any) => {
  return props.children
}

const DefaultLayout = (props: any) => {
  /** ACTIVATE DEV BUTTON */
  const [inputSequence, setInputSequence] = useState("") // do not delete
  const [showDevButton, setShowDevButton] = useState(false)
  const targetPhrase = process.env.DEV_MODE_CODE

  /** ACTIVATE DEV BUTTON */
  useEffect(() => {
    if (targetPhrase == null) return
    const handleKeyPress = (event) => {
      setInputSequence((prev) => {
        const newSequence = prev + event.key
        if (newSequence.includes(targetPhrase)) {
          setShowDevButton(true)
        } else {
          setShowDevButton(false)
        }
        return newSequence
      })
    }

    window.addEventListener("keypress", handleKeyPress)
    return () => {
      window.removeEventListener("keypress", handleKeyPress)
    }
  }, [])

  return (
    // <div
    //   className="overflow-scroll"
    //   style={{
    //     zIndex: -1,
    //   }}
    // >
    <>
      {showDevButton && (
        <div className="fixed left-2 bottom-2 z-[9999] flex flex-col gap-2">
          <div
            className="px-[8px] py-[4px] bg-red-900 text-white cursor-pointer"
            onClick={() => {
              console.log("[props]", props)
            }}
          >{`Log Props`}</div>
          <div
            className="px-[8px] py-[4px] bg-red-900 text-white cursor-pointer"
            onClick={() => {
              let locale = props.preferences?.locale != LOCALES.KO ? LOCALES.KO : LOCALES.JA
              props.setPreferences({ locale })
              console.log("[locale changed]", locale)
            }}
          >{`Change Locale`}</div>
        </div>
      )}
      <Page {...props} />
      {/* <AmbassadorApplicantsToast {...props} /> */}
    </>
    // </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(memo(DefaultLayout))
